import React, { useCallback, useEffect, useRef, useState } from 'react';

import { fetchJson } from '../../../helpers/fetch.js';
import AgGrid, { AgGridWrapper } from '../../common/AgGrid/index.jsx';
const OUTPUT_MODES = {basic: 'basic', advanced: 'advanced'}
import { createDefaultDatagridExportOptions } from '../../common/AgGrid/ExportFilename.jsx';
// const INPUT_GRID_HEIGHT = 450;
// const GRID_DUMMY_STYLE = {
//   display: 'flex',
//   justifyContent: 'center',
//   alignItems: 'center',
//   height: INPUT_GRID_HEIGHT,
//   flexDirection: 'column',
//   border: '1px solid #CCC',
//   background: '#f1f1f1'
// }

import { datagrid_indicator_output_path } from '~/routes';
import { useSelectionColumnClick } from '../../datagrid/hooks/useSelectionColumnClick.js';

const createServerSideDatasource = (state, context) => {
  return {
    // called by the grid when more rows are required
    getRows: params => {
      let isBasicModeInvalid = state.value_def.mode === OUTPUT_MODES.basic && (!state.value_def.aggFunc || (!state.value_def.field && state.value_def.aggFunc !== 'count'));
      let isAdvancedModeInvalid = state.value_def.mode === OUTPUT_MODES.advanced && !state.value_def.formula;

      if (isBasicModeInvalid || isAdvancedModeInvalid) {
        params.success({rowData: [], rowCount: 0});
        return;
      }

      fetchJson(
        datagrid_indicator_output_path({id: 'new', project_id: context?.in_project_context ? context.project_id : null, _options: true}),
        { body: JSON.stringify(state), method: 'POST' }
      ).then(response => {
        if (response) {
          // supply rows for requested block to grid
          params.success({
            rowData: response.rows,
            rowCount: response.rowCount,
          });

          if(response.rows.length == 0) {
            params.api.showNoRowsOverlay()
          } else {
            params.api.hideOverlay()
          }
  
          params.api.setGridOption('columnDefs', response?.additionalColumns);
        } else {
          // inform grid request failed
          params.fail();
          params.api.hideOverlay()
        }
      });
    }
  }
}

const OutputDatagrid = ({state, context = {}, timeout = 0, datagridName, gridRef = null}) => {
  gridRef ||= useRef();

  const onFirstDataRendered = useCallback(() => {
    gridRef.current.api.sizeColumnsToFit();
  }, []);

  const defaultDatasource = useCallback(() => {
    return { getRows: params => {params.success({rowData: [], rowCount: 0})} };
  }, []);

  const [serverSideDatasource, SetServerSideDatasource] = useState(defaultDatasource);

  useEffect(() => {
    // The way it works is that a timer is set to execute the function after xx seconds
    const timer = setTimeout(() => {
      SetServerSideDatasource(() => createServerSideDatasource(state, context));
    }, timeout);

    return () => clearTimeout(timer)
  }, [state]);

  return <AgGridWrapper
    wrapperStyle={{height: 102}} // Always 1 row
  >
    <AgGrid
      ref={gridRef} // Ref for accessing Grid's API
      columnDefs={[]}
      style={{flex: 1}}
      rowModelType={'serverSide'}
      serverSideDatasource={serverSideDatasource}
      groupHeaderHeight={20}
      onFirstDataRendered={onFirstDataRendered}
      gridOptions={createDefaultDatagridExportOptions(datagridName)}
      onCellClicked={useSelectionColumnClick()}
    />
  </AgGridWrapper>
};

export default OutputDatagrid;